import React from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import i18n from '../../../../i18n';
import { Plus, Search, X } from 'lucide-react';
import { SideBar } from '../../components/Sidebar/Sidebar';
import { HomeBanner } from '../../../home/homeBanner';
import { createGroup, deleteGroup, getAllGroups } from '../../../../models/groups';
import { getAllOrganization } from '../../../../models/organization';
import { getUsersByRoles } from '../../../../models/users';
import { getAllSectors } from '../../../../models/sectors';

import './Groups.scss';
import { GroupsTable } from './components/GroupsTable';
import { GroupForm } from './components/GroupForm';
import DataTable from 'react-data-table-component';
import { MzadLoader } from '../../../helpers/mzadLoader';

const customStyles = {
    headCells: {
        style: {
            fontWeight: 'bold',
            backgroundColor: '#e4f7ff',
            color: '#000000',
        },
    },
};

export class Groups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideSidebar: false,
            is_loading: false,
            totalRows: 0,
            currentPage: 1,
            list: {
                page: 1,
                limit: 15,
            },
            groups: [],
            managers: [],
            hse_users: [],
            organizations: [],
            sectors: [],
            showForm: false,
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
    }

    componentDidMount() {
        let { list } = this.state;
        let qstring = new URLSearchParams(list).toString();
        this.loadAllGroups(qstring);
        this.loadUsersByRoles();
        this.loadAllOrganisation();
        this.loadAllSectors();
    }

    async loadAllOrganisation() {
        const response = await getAllOrganization();
        let organizations = response.data;
        this.setState({ organizations });
    }

    async loadAllSectors() {
        const response = await getAllSectors();
        let sectors = response.data;
        this.setState({ sectors });
    }

    handlePageChange(page) {
        window.scrollTo(0, 250);
        let { list } = this.state;
        let currentPage = page;
        list['page'] = currentPage;
        this.setState({ currentPage: currentPage, list: list });
        let qstring = new URLSearchParams(list).toString();
        this.loadAllGroups(qstring);
    }

    async loadUsersByRoles() {
        let q = `roles=PM,HSE&is_role_wise=${true}`;
        const response = await getUsersByRoles(q);
        let managers = response.data['PM'];
        let hse_users = response.data['HSE'];
        this.setState({ managers, hse_users });
    }

    async loadAllGroups(qstring) {
        this.setState({ is_loading: true });
        const response = await getAllGroups(qstring);
        if (response.success) {
            let groups = response.data;
            let meta = response.meta;
            this.setState({
                groups,
                totalRows: meta.total,
                is_loading: false
            });
        } else {
            this.setState({ is_loading: false });
        }
    }

    async handleFormSubmit(payload) {
        // Validation
        console.log(payload)
        if (
            !payload.project_code ||
            !payload.sector_id ||
            !payload.actual_start_date ||
            !payload.expected_end_date ||
            !payload.group_name ||
            !payload.manager ||
            !payload.hse ||
            !payload.organization ||
            !payload.start_date ||
            !payload.end_date ||
            !payload.reg_start_date ||
            !payload.reg_end_date ||
            !payload.client ||
            !payload.client.client_name ||
            !payload.client.focal_name ||
            !payload.client.email ||
            !payload.client.mobile
        ) {
            swal('Failed', 'Missing mandatory fields!!!', 'error');
            return;
        }

        if (payload.is_service_charge_included && !payload.service_charge_included) {
            swal(
                'Validation Error',
                'Service charge included field is required. Please fill it out to continue.',
                'error'
            );
            return;
        }

        // Create FormData
        const formData = new FormData();

        // Append all form fields
        Object.keys(payload).forEach(key => {
            if (key === 'client') {
                Object.keys(payload.client).forEach((clientKey) => {
                    formData.append(`client[${clientKey}]`, payload.client[clientKey]);
                });
            } else if (key === 'enquiries') {
                formData.append('enquiries', JSON.stringify(payload.enquiries));
            } else if (key.startsWith('file_')) {
                if (payload[key]) {
                    formData.append(key, payload[key]);
                }
            } else {
                formData.append(key, payload[key]);
            }
        });

        // API call
        const response = await createGroup(formData);

        if (response.success) {
            swal(i18n.t('success'), response.message, 'success', {
                buttons: false,
                timer: 2000,
            });

            // Reload groups list
            let { list } = this.state;
            let qstring = new URLSearchParams(list).toString();
            this.loadAllGroups(qstring);

            // Hide form
            this.setState({ showForm: false });
        } else {
            let error_message = response.message;
            let resObject = response.error;
            for (const key in resObject) {
                if (Object.hasOwnProperty.call(resObject, key)) {
                    let element = resObject[key];
                    error_message += '\n' + element;
                }
            }
            swal('Failed', error_message, 'error');
        }
    }

    handleEdit(groupId) {
        // Navigate to edit page
        window.location.href = `/edit_group/${groupId}`;
    }

    handleSidebar = (hideSidebar) => {
        this.setState({ hideSidebar: hideSidebar });
    }

    handleDelete(id) {
        swal({
            title: 'Confirm Deletion',
            text: 'Are you sure you want to delete this group?',
            icon: 'warning',
            buttons: ['Cancel', 'Delete'],
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                try {
                    await deleteGroup(id);
                    swal(i18n.t('success'), 'Item deleted', 'success', {
                        buttons: false,
                        timer: 2000,
                    });

                    // Reload groups list
                    let { list } = this.state;
                    let qstring = new URLSearchParams(list).toString();
                    this.loadAllGroups(qstring);
                } catch (error) {
                    console.error('Error deleting group:', error);
                    swal('Failed', 'Something went wrong', 'error');
                }
            }
        });
    }

    toggleForm() {
        this.setState(prevState => ({
            showForm: !prevState.showForm
        }));
    }

    // Handles Active / Previous button click
    handleFilterChange = async (type) => {
        this.setState({ activeTab: type });
        const qstring = new URLSearchParams({
            ...this.state.list,
            status: type === 'active' ? 'A' : 'P',
            search: this.state.searchText || ''
        }).toString();

        await this.loadAllGroups(qstring);
    };

    // Handles search with debounce
    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchText: value });

        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.handleFilterChange(this.state.activeTab || 'active');
        }, 500);
    };


    render() {
        const {
            groups,
            managers,
            hse_users,
            organizations,
            sectors,
            is_loading,
            showForm,
            hideSidebar
        } = this.state;

        return (
            <React.Fragment>
                {/* <HomeBanner /> */}
                <section className="sptb mt-5 group-list-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!hideSidebar && <SideBar />}
                            </div>
                            <div className={hideSidebar ? 'col-xl-12 col-lg-12 col-md-12 pb-5' : 'col-xl-9 col-lg-12 col-md-12 pb-5'}>

                                <div className="groups-header">
                                    {/* Tabs - Active / Previous */}
                                    <div className="tabs">
                                        <button
                                            className={`btn btn-primary-custom ${this.state.activeTab === 'active' ? '' : 'active'}`}
                                            onClick={() => this.handleFilterChange('active')}
                                        >
                                            {i18n.t('active')}
                                        </button>
                                        <button
                                            className={`btn btn-primary-custom ${this.state.activeTab === 'previous' ? '' : 'active'}`}
                                            onClick={() => this.handleFilterChange('previous')}
                                        >
                                            
                                            {i18n.t('previous')}
                                        </button>
                                    </div>

                                    {/* Search Box */}
                                    <div className="search-box">
                                        <Search className="search-icon" size={18} />
                                        <input
                                            type="text"
                                            placeholder={i18n.t('search')}
                                            value={this.state.searchText || ''}
                                            onChange={this.handleSearchChange}
                                        />
                                    </div>

                                    {/* Add / Close Form Button */}
                                    <button
                                        className={`btn btn-primary-custom ${this.state.showForm ? 'close' : 'add'}`}
                                        onClick={this.toggleForm}
                                    >
                                        {this.state.showForm ? (
                                            <>
                                                <X size={18} />
                                                <span style={{margin:"10px"}}>Close Form</span>
                                            </>
                                        ) : (
                                            <>
                                                <Plus size={18} />
                                                <span style={{margin:"10px"}}>{i18n.t('add_new_group')}</span>
                                            </>
                                        )}
                                    </button>
                                </div>



                                {showForm && (
                                    <div className="form-wrapper">
                                        <GroupForm
                                            onSubmit={this.handleFormSubmit}
                                            onCancel={this.toggleForm}
                                            managers={managers}
                                            hseUsers={hse_users}
                                            organizations={organizations}
                                            sectors={sectors}
                                        />
                                    </div>
                                )}

                                <div className="list-wrapper">
                                    <GroupsTable
                                        groups={groups}
                                        onEdit={this.handleEdit}
                                        onDelete={this.handleDelete}
                                        isLoading={is_loading}
                                        currentPage={this.state.currentPage}
                                        totalRows={this.state.totalRows}
                                        rowsPerPage={this.state.list.limit}
                                        onPageChange={this.handlePageChange}
                                        hideSidebar={this.state.hideSidebar}
                                        handleSidebar={this.handleSidebar}
                                        onRowsPerPageChange={(size) => {
                                            let { list } = this.state;
                                            list.limit = size;
                                            this.setState({ list });
                                            this.handlePageChange(1);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

